// extracted by mini-css-extract-plugin
module.exports = {"Order":"Order_Order__3kYZJ","Header":"Order_Header__pSgg5","Ingredient":"Order_Ingredient__3TktI"};